import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-shape-color',
  styleUrls: ['context-menu-shape-color.component.scss'],
  templateUrl: './context-menu-shape-color.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuShapeColorComponent {
  @Input()
  color?: string;

  @Output()
  colorChanged = new EventEmitter<string | undefined>();

  defaultColor = '#FFF';
}
